import { getIconForTitle } from "@/features/marketing-content/utils/icon-map";

import type { Recommendations } from "@/content/alternatives/schema";

export function RecommendationSection({ heading, description, items }: Recommendations) {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="mx-auto max-w-5xl px-6">
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="font-clash text-3xl font-medium leading-tight tracking-snug text-ash-900 md:text-5xl">
            {heading}
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-ash-500">{description}</p>
        </div>

        <div className="mt-12 space-y-6">
          {items.map((item) => {
            const Icon = getIconForTitle(item.boldText);
            return (
              <div key={item.boldText} className="flex gap-4">
                <div className="mt-1 flex size-10 shrink-0 items-center justify-center rounded-xl bg-rebolt-500/10">
                  <Icon className="size-5 text-rebolt-500" />
                </div>
                <div>
                  <p className="text-lg font-semibold text-ash-900">{item.boldText}</p>
                  <p className="mt-1 text-base leading-relaxed text-ash-500">{item.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
